import React from 'react';
import TableManager from '../components/data/TableManager';

// Configuration for SKE_TipiValidazioni columns
const columnConfig = [
  "TIV_Id_TipiValidazioni=0,ID,isPrimaryKey",
  "TIV_IdRif_TipiValidazioni=0,ID Rif.,type=number",
  "TIV_Codice=2,Codice,required",
  "TIV_Descrizione=2,Descrizione,required",
  "TIV_CodiceTipoZod=2,Pattern Zod",
  "TIV_CodiceTipoC=2,Pattern C#",
  "TIV_StatiRecord=0,Stato Record",
  "TIV_InizioValidita=0,Inizio Validità,type=datetime",
  "TIV_FineValidita=0,Fine Validità,type=datetime",
  "TIV_UtenteInserimento=0,Utente Inserimento",
  "TIV_TerminaleInserimento=0,Terminale Inserimento",
  "TIV_DataOraInserimento=0,Data/Ora Inserimento,type=datetime",
  "TIV_UtenteModifica=0,Utente Modifica",
  "TIV_TerminaleModifica=0,Terminale Modifica",
  "TIV_DataOraModifica=0,Data/Ora Modifica,type=datetime",
  "TIV_Timestamp=0,Timestamp DB,type=datetime",
];

const filterConfig = [
  { field: 'TIV_Codice', label: 'Codice', type: 'text' },
  { field: 'TIV_Descrizione', label: 'Descrizione', type: 'text' },
  { field: 'TIV_CodiceTipoZod', label: 'Pattern Zod', type: 'text' },
  { field: 'TIV_CodiceTipoC', label: 'Pattern C#', type: 'text' },
];

const inputTypes = {
  TIV_Descrizione: 'textarea',
  TIV_CodiceTipoZod: 'textarea',
  TIV_CodiceTipoC: 'textarea',
  TIV_InizioValidita: 'datetime-local',
  TIV_FineValidita: 'datetime-local',
};

const TipiValidazioniPage = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
        Gestione Tipi Validazioni
      </h1>
      <TableManager
        tableName="SKE_TipiValidazioni"
        primaryKey="TIV_Id_TipiValidazioni"
        pageTitle="Gestione Tipi Validazioni"
        columnConfig={columnConfig}
        filterConfig={filterConfig}
        inputTypes={inputTypes}
        enableCreate={true}
        enableEdit={true}
        enableDelete={true}
        defaultSortField="TIV_Id_TipiValidazioni"
        defaultSortDirection="asc"
      />
    </div>
  );
};

export default TipiValidazioniPage;
